import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link, Grid } from "@material-ui/core";
import { Link as RouterLink, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../firebase/AuthProvider";
import { useMenu } from "./MenuContext";
import Avatar from "../shared/Avatar";
import { colors } from "../../theme";
import Button from "../shared/Button";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingLeft: "35px",
    paddingRight: "35px",
  },
  avatar: {
    width: "70px",
    height: "70px",
    fontSize: "32px",
    border: "2px solid #FFFFFF",
    color: colors.AVATAR_LETTER_TEXT,
  },
  displayname: {
    fontSize: "20px",
    fontWeight: 900,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "3.54",
    letterSpacing: "-0.05px",
    maxWidth: "250px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    paddingLeft: "15px",
  },
  link: {
    color: colors.MENU_PROFILE_LINK,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
  },
  signoutContainer: {
    paddingLeft: "100px",
  },
  signOutButton: {
    width: "120px",
    marginBottom: "10px",
  },
}));

export default function UserProfileMenu() {
  const classes = useStyles();
  const { signOut, user } = useAuth();
  const { t } = useTranslation();
  const { closeMenu } = useMenu();

  const history = useHistory();

  async function signOutClick() {
    closeMenu();
    await signOut();
    history.push("/");
  }

  if (!user) return null;

  return (
    <Grid container item direction="row" className={classes.container}>
      <Grid item>
        <Link
          component={RouterLink}
          to="/profile"
          onClick={closeMenu}
          className={classes.link}
        >
          <Avatar className={classes.avatar}>{user.avatar}</Avatar>
        </Link>
      </Grid>
      <Grid item className={classes.displayname}>
        <Link
          component={RouterLink}
          to="/profile"
          onClick={closeMenu}
          className={classes.link}
        >
          {user.displayname}
        </Link>
      </Grid>
      <Grid item className={classes.signoutContainer}>
        <Button onClick={signOutClick} className={classes.signOutButton}>
          {t("header.signout")}
        </Button>
      </Grid>
    </Grid>
  );
}
